import $ from 'jquery';
import Base from '../../../_config/base';

class FooterLanguage extends Base {
  constructor(el) {
    super(el);

    $(document).on('click', 'a.language-item', (e) => {
      e.preventDefault();
      let currURL = window.location.href;
      let isDev = false;
      let result = '';
      if (currURL.indexOf('/author/') > 0 || currURL.indexOf('/public/') > 0) {
        isDev = true;
      }
      if (currURL.indexOf('/en/') > 0) {
        currURL = currURL.replace('/en/', '/');
      }
      if (currURL.indexOf('/fr/') > 0) {
        currURL = currURL.replace('/fr/', '/');
      }
      if (currURL.indexOf('/it/') > 0) {
        currURL = currURL.replace('/it/', '/');
      }
      if (currURL.indexOf('/de/') > 0) {
        currURL = currURL.replace('/de/', '/');
      }

      const arr = currURL.split('/');
      if (isDev) {
        result = arr[0].concat('//', arr[2], '/', arr[3]);
      } else {
        result = arr[0].concat('//', arr[2]);
      }
      const $clickedItem = $(e.target);

      // Redirect to the Language-Specific-URL
      window.location.href = result.concat('/', $clickedItem.data('language'), currURL.substring(result.length));
    });

    $(document).ready(() => {
      const currURL = window.location.href;

      if (currURL.indexOf('/en/') > 0) {
        $('.language-item span[data-language="en"]').closest('.language-item').addClass('language-selected');
        return;
      }

      if (currURL.indexOf('/fr/') > 0) {
        $('.language-item span[data-language="fr"]').closest('.language-item').addClass('language-selected');
        return;
      }

      if (currURL.indexOf('/it/') > 0) {
        $('.language-item span[data-language="it"]').closest('.language-item').addClass('language-selected');
        return;
      }

      $('.language-item span[data-language="de"]').closest('.language-item').addClass('language-selected');
    });
  }
}

FooterLanguage.className = 'FooterLanguage';
export default FooterLanguage;



// WEBPACK FOOTER //
// ./src/materials/molecules/footer/footer-language.js